import AsOfDate from './AsOfDate';
import Boolean from './Boolean';
import Checklist from './Checklist';
import Choice from './Choice';
import Currency from './Currency';
import DateRange from './DateRange';
import Integer from './Integer';
import MultiSelect from './MultiSelect';
import Search from './Search';
import Select from './Select';
import Text from './Text';

export default {
    search: Search,
    text: Text,
    boolean: Boolean,
    checklist: Checklist,
    select: Select,
    'multi-select': MultiSelect,
    currency: Currency,
    dateRange: DateRange,
    choice: Choice,
    integer: Integer,
    asOfDate: AsOfDate
};
